/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Button, Box, InputAdornment, Tooltip, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import Service from '../Service';
import Chip from '@material-ui/core/Chip';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import QRCode from 'react-qr-code';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useRef } from 'react';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import Checkbox from '@material-ui/core/Checkbox';
import Barcode from "react-barcode";

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};
const MultipleQRPDF = ({ qrData }) => {
    return (
        <div>
            {qrData.map((item, index) => (
                <div
                    key={index}
                    style={{
                        pageBreakAfter: index < qrData.length - 1 ? "always" : "avoid",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "297mm",
                        width: "210mm",
                        backgroundColor: 'white',
                        pageBreakInside: 'avoid',
                        padding: "20mm",
                        boxSizing: "border-box"
                    }}
                >
                    <img
                        src="/static/cargills-agri-logo01.png"
                        alt="Cargills Logo"
                        style={{
                            maxWidth: "300px",
                            marginBottom: "40px",
                            flexShrink: 0
                        }}
                    />

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "40px",
                        flexShrink: 0
                    }}>
                        <QRCode value={item.vehicleTagNumber || ""} size={470} />
                    </div>
                    <div style={{
                        marginTop: 20,
                        width: "470px",
                        display: "flex",
                        justifyContent: "center"
                    }}>
                        <Barcode
                            value={item.vehicleTagNumber || ""}
                            width={3}
                            height={160}
                            fontOptions="bold"
                            displayValue={false}
                            margin={0}
                        />
                    </div>
                    <div style={{
                        fontSize: 37,
                        fontWeight: "bold",
                        width: "100%",
                        wordWrap: "break-word",
                        textAlign: "center",
                        fontFamily: "'DIN Condensed', 'Arial Narrow', sans-serif",
                        letterSpacing: "4px",
                        color: "#000",
                        flexShrink: 0
                    }}>
                        {item.vehicleTagNumber || ""}
                    </div>
                </div>
            ))}

            <style>
                {`
                    @media print {
                        body {
                            margin: 0;
                            background: white !important;
                        }
                        @page {
                            size: A4;
                            margin: 0;
                        }
                        * {
                            -webkit-print-color-adjust: exact !important;
                            color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                    }
                `}
            </style>
        </div>
    );
};
export default function VehicleMasterListing(props) {
    const componentRef = useRef();
    const multipleQRRef = useRef();
    const screenCode = 'VEHICLEMASTER';
    let encrypted = "";
    const navigate = useNavigate();
    const [date, setDate] = useState(new Date());
    const [qrCode, setQRCode] = useState("");
    const [selectedQRData, setSelectedQRData] = useState([]);
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        dataID: date.toISOString().split('T')[0]
    });
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [selectedRows, setSelectedRows] = useState([]);

    const addSpecialOrderSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number()
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID
        },
        validationSchema: addSpecialOrderSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetVehicleDetailsByGroupIDOperationEntityID())
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map(row => row.vehicleID));
        } else {
            setSelectedRows([]);
        }
    };

    const isAllSelected = tableData.length > 0 && selectedRows.length === tableData.length;
    const prepareSelectedQRData = () => {
        const selectedVehicles = tableData.filter(vehicle => selectedRows.includes(vehicle.vehicleID));
        const qrData = selectedVehicles.map(vehicle => ({
            vehicleTagNumber: vehicle.vehicleTagNumber,
            vehicleCode: vehicle.vehicleCode,
            vehicleNumber: vehicle.vehicleNumber,
            factoryName: vehicle.factoryName
        }));
        setSelectedQRData(qrData);
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 100);
        });
    };

    const handleSingleQRDownload = (vehicleTagNumber) => {
        setQRCode(vehicleTagNumber);
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 100);
        });
    };

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWVEHICLEMASTER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        });
        trackPromise(GetAllGroups());
    }

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetVehicleDetailsByGroupIDOperationEntityID())
    }, [formik.values.groupID]);

    useEffect(() => {
        setTableData([]);
    }, [formik.values.operationEntityID, formik.values.dateID]);

    async function GetAllGroups() {
        var res = await Service.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await Service.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    async function clearAll() {
        setTableData([]);
        setSelectedRows([]);
        setValues({
            ...values,
            operationEntityID: 0
        })
    }

    function handleClick(vehicleID) {
        encrypted = AESEncryptionParam(vehicleID.toString());
        navigate('/dashboard/VehicleMaster/AddEdit/' + encrypted)
    }

    async function GetVehicleDetailsByGroupIDOperationEntityID() {
        var res = await Service.GetVehicleDetailsByGroupIDOperationEntityID(formik.values.groupID, formik.values.operationEntityID);
        if (res != null) {
            setTableData(res);
        }
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Vehicle Master  |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/VehicleMaster/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Vehicle Master"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Distribution Center"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> All Fresh Collection Centers</MenuItem>
                                        {operationEntityList.map((option) => (
                                            option.factoryType == 1 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        color='error'
                                        variant="outlined"
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        type="submit"
                                        color='secondary'
                                        variant="outlined"
                                    >Search</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br /><Divider variant="middle" /><br />

                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Vehicle Master" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">
                                                    <Checkbox
                                                        color="secondary"
                                                        onChange={handleSelectAll}
                                                        checked={isAllSelected}
                                                    />
                                                    Select All
                                                </TableCell>
                                                <TableCell align="left">Fresh Distribution Center</TableCell>
                                                <TableCell align="left">Vehicle Code</TableCell>
                                                <TableCell align="left">Vehicle Reg Number</TableCell>
                                                <TableCell align="left">Vehicle Ownership</TableCell>
                                                <TableCell align="left">Payment Type</TableCell>
                                                <TableCell align="center">QR</TableCell>
                                                <TableCell align="center">Download QR</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.vehicleID}>
                                                    <TableCell align="center">
                                                        <Checkbox
                                                            color="secondary"
                                                            checked={selectedRows.includes(row.vehicleID)}
                                                            onChange={(event) => {
                                                                if (event.target.checked) {
                                                                    setSelectedRows([...selectedRows, row.vehicleID]);
                                                                } else {
                                                                    setSelectedRows(selectedRows.filter(id => id !== row.vehicleID));
                                                                }
                                                            }}
                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.factoryName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.vehicleCode}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.vehicleNumber}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.vehicleOwnershipTypeName || '-'}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row">
                                                        {row.vehiclePaymentTypeName || '-'}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <QRCode value={row.vehicleTagNumber} size={56} />
                                                    </TableCell>
                                                    <TableCell align="center" >
                                                        <ReactToPrint
                                                            documentTitle={"Cargills Vehicle QR"}
                                                            trigger={() =>
                                                                <Tooltip title="Download QR">
                                                                    <IconButton
                                                                        id="btnRecord"
                                                                        type="submit"
                                                                        variant="contained"
                                                                    >
                                                                        <GetAppIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            }
                                                            onBeforeGetContent={() => handleSingleQRDownload(row.vehicleTagNumber)}
                                                            content={() => componentRef.current}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.isActive == true ?
                                                            <Chip size="small" label="Active" style={{ color: 'green' }} /> :
                                                            <Chip size="small" label="InActive" style={{ color: 'red' }} />
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Tooltip title="Edit Vehicle">
                                                            <IconButton aria-label="delete" onClick={() => handleClick(row.vehicleID)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={10} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={10}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }

                    <div style={{ display: 'none' }}>
                        <div ref={componentRef}>
                            <CreatePDF vehicleTagNumber={qrCode} />
                        </div>
                    </div>

                    <div style={{ display: 'none' }}>
                        <div ref={multipleQRRef}>
                            <MultipleQRPDF qrData={selectedQRData} />
                        </div>
                    </div>

                    {tableData.length > 0 && (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <ReactToPrint
                                documentTitle={"Selected Vehicle QRs"}
                                trigger={() =>
                                    <Button
                                        type="button"
                                        color="secondary"
                                        variant="contained"
                                        disabled={selectedRows.length === 0}
                                        style={{ marginBottom: '10px' }}
                                    >
                                        Download
                                    </Button>
                                }
                                onBeforeGetContent={prepareSelectedQRData}
                                content={() => multipleQRRef.current}
                            />
                        </Box>
                    )}
                </Container>
            </Page>
        </>
    );
}